import { GlobalEffects } from './global.effects';

export const globalEffects = [GlobalEffects];

export * from './global.effects';
